import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { Program } from '@fitscovery/workouts/data-access';
import { Select } from '@ngxs/store';
import { MembershipState } from '@fitscovery/membership/data-access';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

class DisplayData {
  count: number;
  loadMore: boolean;
}

@Component({
  selector: 'fitscovery-ui-program-list-card',
  templateUrl: './ui-program-list-card.component.html',
  styleUrls: ['./ui-program-list-card.component.scss']
})
export class UiProgramListCardComponent implements OnInit, OnChanges {
  @Input() programData: Program[];
  @Select(MembershipState.hasActiveStatus) hasActiveMembershipStatus$: Observable<boolean>;
  isStatusPending: boolean;
  isActive: boolean;
  isLoading: boolean;
  programValue: string;

  dataDisplayCount: number;
  showLoadMore: boolean;
  openForMembersOnly: boolean;
  hasActiveMembershipStatus: boolean;

  constructor(private router: Router) { }

  ngOnInit(): void {
    this.isActive = false;
    this.isLoading = true;
    this.programData = [];
    this.setDataDisplayLimit();

    this.hasActiveMembershipStatus$.pipe(take(1)).subscribe(async (hasActiveMembershipStatus) => {
      this.hasActiveMembershipStatus = hasActiveMembershipStatus;
      this.isStatusPending = !hasActiveMembershipStatus;
    });
  }

  ngOnChanges(changes: any) {
    this.programValue = changes.programData.currentValue;

    if (this.programValue !== undefined) {
      this.isLoading = false;
      this.setDataDisplayLimit();
    }
  }

  goToProgramDetails(programId: any, isForMembersOnly: any) {
    if (isForMembersOnly === true && this.isStatusPending) {
      this.openForMembersOnly = !this.openForMembersOnly;
    } else {
      this.router.navigate([`workouts/programs/${programId}`]);
    }
  }

  bookmarkCard() {
    this.isActive = !this.isActive;
  }

  setDataDisplayLimit() {
    if (this.programData) {
      const totalData = this.programData.length;
      const initialDisplay = 50;
      const initialDisplayData = this.setInitialDisplayData(totalData, initialDisplay);

      this.dataDisplayCount = initialDisplayData.count;
      this.showLoadMore = initialDisplayData.loadMore;
    }
  }

  displayData() {
    const totalData = this.programData.length;
    const increment = 50;
    const count = this.dataDisplayCount;
    const displayData = this._displayData(totalData, increment, count);

    this.dataDisplayCount = displayData.count;
    this.showLoadMore = displayData.loadMore;
  }

  backToList(x?: any) {
    this.openForMembersOnly = !this.openForMembersOnly;
  }

  setInitialDisplayData(data: number, initial: number): DisplayData {
    const dataCount = data > initial ? initial : data;
    const loadMore = data > initial ? true : false;

    return {
        count: dataCount,
        loadMore: loadMore
    };
  }

  _displayData(data: number, increment: number, count: number): DisplayData {
      var displayIncrement: number = 0;

      if (data > count) {
          const remaining = data - count;
          displayIncrement = increment > remaining ? remaining : increment;
      }

      const displayedData = count + displayIncrement; 
      const remainingData = data - displayedData;
      const dataCount = data >= displayedData ? displayedData : count += remainingData;
      const loadMore = (remainingData <= 0) ? false : true;

      return {
          count: dataCount,
          loadMore: loadMore
      };
  }
}
